<template>
    <modal name="today-category-delete-modal" class="member-out-modal event-delete-modal"
           :width="'30%'"
           :height="'auto'"
           @before-close="handlerBeforeClose"
           @before-open="handlerBeforeOpen"
           @opened="handlerOpened"
    >
        <div class="keymodal_title">
      <span class="keymodal_title_txt">
      </span>
            <div class="out_title">카테고리 삭제</div>
        </div>
        <div class="pb30">
            <div class="c_table_wrap pt40 text_center">
                <div class="">
                    <p class="fs16">정말로 카테고리를 삭제하시겠습니까?</p>
                    <p>삭제시 카테고리 내 게시물이 전부 삭제됩니다.</p>
                    <p>삭제 후에는 복구가 불가능합니다.</p>
                </div>
                <div class="text_left out_table">
                    <el-input class=" mt3" type="password" v-model="mb_password" placeholder="관리자 비밀번호"></el-input>
                    <div class="input_error">{{ validation.firstError('mb_password') }}</div>

                </div>
            </div>
            <div class="text_center pt50">
                <el-button type="info" class="out_btn" @click="closeModal()">취소</el-button>
                <el-button type="info" class="out_btn" @click="eventDelete()">확인</el-button>
            </div>
        </div>
    </modal>
</template>

<script>
import Vue from 'vue';
import SimpleVueValidation from 'simple-vue-validator';

const Validator = SimpleVueValidation.Validator;
import VuxAlert from '@/mixins/alertMixins';

Vue.use(SimpleVueValidation);

let params = {};

export default {
    name: "TodayCategoryDeleteModal",
    mixins: [VuxAlert],
    props: {
        categoryData: {default: {}},
        successFunc: {
            default: () => {
            }
        },
    },
    data() {
        return {
            mb_password: '',
        }
    },
    validators: {
        mb_password: function (value) {
            return Validator.value(value)
                .required('비밀번호를 입력해주세요.')
        },
    },
    methods: {
        handlerBeforeOpen(event) {
            this.initData();
        },
        handlerOpened() {
        },
        handlerBeforeClose() {
        },
        closeModal() {
            this.$modal.hide('today-category-delete-modal');
        },
        initData() {
            this.mb_password = '';
        },
        eventDelete() {
            this.$validate(['mb_password']).then((success) => {
                if (success) {
                    let params = {
                        bc_idx: this.categoryData.bc_idx,
                        mb_password: this.mb_password,
                    };
                    try {
                        this.$api.$today.deleteTodayCategory(params).then(res => res.Data.Result).then(res => {
                            let type = this.todayDeleteReturnType(res.Info.Type);
                            if (type === true) {
                                this.createAlert({
                                    title: '카테고리 삭제',
                                    content: '카테고리가 삭제되었습니다.',
                                    btnText: '확인',
                                    hide: () => {
                                        this.successFunc();
                                        this.closeModal();
                                    }
                                })
                            } else {
                                this.errorAlert(type);
                            }
                        })
                    } catch (e) {
                        console.log(e);
                    }
                } else {
                    this.errorAlert('비밀번호를 입력해주세요.');
                }
            });
        },
        todayDeleteReturnType(type) {
            switch (type) {
                case 1:
                    return true;
                default:
                    return '카테고리 삭제에 실패하였습니다. 잠시후 다시 시도 해주세요.';
            }
        },
    }
}
</script>

<style scoped>

</style>
